<mat-card>
	<mat-card-header>
		<mat-card-title class="font-weight-normal">
			<div fxLayout="row" fxLayoutAlign="center center">
				<div class="font-size-16" fxFlex="100">Load Detail</div>
			</div>
		</mat-card-title>
	</mat-card-header>
	<mat-divider></mat-divider>

	<app-default-progress-bar *ngIf="quote == null"></app-default-progress-bar>

	<mat-card-content *ngIf="quote != null">
		<app-column-details [dataSource]="detailsView"> </app-column-details>

		<div class="padding-0-5 font-size-16" fxLayout="row" fxLayoutAlign="top left">
			<div fxFlex>
				<div class="label-text-light textWithIcon" fxFlex="50">
					<mat-icon class="primary-light-color m-r-1">person</mat-icon>
					<b>Customer</b>
				</div>
				<div class="label-text-light" fxFlex="50" fxLayoutAlign="center center">
					{{ customer ? TITLE_CASE(customer.name) : '-' }}
				</div>
			</div>

			<div fxFlex>
				<div *ngIf="accountSettings.SHOW_LOADS_PREDICTED_PRICE && quote?.predictedPrice">
					<div class="textWithIcon" fxFlex>
						<i class="material-icons primary-light-color m-r-1">attach_money</i>
						<b class="font-weight-700">Predicted Price</b>
					</div>
					<div class="label-text-light" fxFlex fxLayoutAlign="center center">
						{{ TO_DOLLARS(quote?.predictedPrice) | currency: 'USD' }}
					</div>
				</div>
			</div>
		</div>

		<div
			*ngIf="SHOW_LOAD_URL"
			class="padding-0-5 font-size-16"
			fxLayout="row"
			fxLayoutAlign="top left"
			fxLayoutGap="1rem"
		>
			<div class="label-text-light textWithIcon" fxFlex="25">
				<mat-icon class="primary-light-color" style="margin-right: 1rem">link</mat-icon>
				<b>Load URL</b>
			</div>
			<div class="label-text-light" fxFlex="75" fxLayoutAlign="start start">
				{{ LOAD_URL }}
			</div>
		</div>

		<div
			class="padding-0-5 font-size-16"
			fxLayout="row"
			fxLayoutAlign="top left"
			fxLayoutGap="1rem"
		>
			<div class="label-text-light textWithIcon" fxFlex="25">
				<mat-icon class="primary-light-color" style="margin-right: 1rem">edit</mat-icon>
				<b>Instructions</b>
			</div>
			<div class="label-text-light" fxFlex="75">
				<app-special-instructions-dialog
					[layoutAlign]="'center center'"
					[specialInstructions]="quote.specialInstructions"
				>
				</app-special-instructions-dialog>
			</div>
		</div>

		<div
			*ngIf="isEditQuote"
			class="padding-0-5"
			fxLayout="row"
			fxLayoutAlign="end end"
			fxLayoutGap="1rem"
		>
			<button
				(click)="$event.stopPropagation(); rerunLoad()"
				*ngIf="!isLoading"
				color="primary"
				mat-raised-button
				[matTooltipDisabled]="DIFFERENCE_FROM_NOW(quote.created, 'minutes') > 30"
				matTooltip="{{
					'Available in ' + (30 - DIFFERENCE_FROM_NOW(quote.created, 'minutes')) + ' minute(s)'
				}}"
				matTooltipClass="custom-tooltip"
				[disabled]="DIFFERENCE_FROM_NOW(quote.created, 'minutes') < 31 || rerunRequestSent"
			>
				Rerun Load
			</button>
			<mat-spinner [diameter]="30" *ngIf="isLoading"></mat-spinner>

			<app-post-load
				(updatedData)="quote = $event; quoteUpdated.emit($event); buildView()"
				[isEditQuote]="true"
				[quote]="quote"
			></app-post-load>
		</div>
	</mat-card-content>
</mat-card>
